import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "pdf-viewer-page d-flex flex-column h-100" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between px-6 py-3 bg-white border-bottom" }
const _hoisted_3 = { class: "d-flex align-items-center gap-3" }
const _hoisted_4 = { class: "mb-0 fw-bold" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_7 = {
  class: "flex-1",
  style: {"flex":"1","overflow":"hidden"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PdfViewer = _resolveComponent("PdfViewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-light-secondary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "arrow-left",
            class: "me-1"
          }),
          _createTextVNode(" Quay lại ")
        ]),
        _createElementVNode("h5", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
          (_ctx.titleSuffix)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " – " + _toDisplayString(_ctx.titleSuffix), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _renderSlot(_ctx.$slots, "header-right", {}, () => [
        (_ctx.count > 0 && _ctx.countLabel)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.count) + " " + _toDisplayString(_ctx.countLabel), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_PdfViewer, {
        source: _ctx.source,
        "file-name": _ctx.fileName,
        loading: _ctx.loading,
        "loading-message": _ctx.loadingMessage
      }, null, 8, ["source", "file-name", "loading", "loading-message"])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}